<template>
    <div class="ds-status-chip" :class="[{ 'ds-status-chip-closed': status?.value === 'completed' }, { 'ds-status-chip-open': status?.value === 'open' }, { 'ds-status-chip-waiting': status?.value === 'responded' }]">
        {{ status?.name }}
    </div>
</template>

<script setup lang="ts">
    import { useExchangeStore } from '@/stores/exchangeStore'
    import { computed } from 'vue'

    const store = useExchangeStore()
    const props = defineProps(['status'])   
    const status = computed(() => store.vacancyStatuses.find(item => item.value === props.status ))
</script>
